import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'
import router from '@/router'
export default class InvalidAccessTokenException extends BaseErrorHandler {
    protected AlertType: AlertTypeEnum = AlertTypeEnum.ERROR;
    protected Code: string = "InvalidAccessTokenException";
    constructor(messageKey?: string, message?: string) {
        super(messageKey, '无效的AccessToken');
    }
    customizeAction(): void {
        //router.replace({name: 'AccessDenied'})
    }
}
